import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setVariantsQuantity } from '../../actions/orders';
import { customSelectStyles } from '../../utilities/helperUtility';
import Select from '../../components/Common/Select';
import ProductOptions from './ProductOptions.js';
import { stringToBoolean } from '../../utilities/conversionUtility';

class Index extends Component {
  state = {
    selectedOptions: {}
  };

  onVariantsChange = this.onVariantsChange;

  onVariantsChange(id) {
    const { variants, setVariantsQuantity } = this.props;
    const currentVariant = variants.find(variant => variant.external_id === id);
    const externalId = currentVariant ? currentVariant.external_id : null;

    setVariantsQuantity(`${externalId}_quantity`, 1, {
      singleVariant: true,
    });
  }

  variantOptions() {
    const { variants, priceSymbol } = this.props;
    const price = id => variants.find(x => x.external_id === id).price;

    return variants.map(({ external_id, title }) => ({
      label: `${title} ${priceSymbol}${price(external_id)}`,
      value: external_id,
    }));
  }

  handleProductOptionClick(option, value) {
    const { selectedOptions } = this.state;
    const { variants, options } = this.props;
    if (!value) value = options.find(x => x.name == option).values[0];
    if (selectedOptions[option] === value) return;
    selectedOptions[option] = value;
    const variant = variants.find(x => JSON.stringify(x.options) === JSON.stringify(Object.values(selectedOptions)));
    this.onVariantsChange(variant ? variant.external_id : null);
  }
  
  render() {
    const {
      variantSelected,
      className,
      optionsStyles,
      selectStyles,
      setting,
      options,
    } = this.props;

    const useSwatches = stringToBoolean(setting.use_swatches);

    if (useSwatches) {
      return (
        <ProductOptions
          options={options}
          defaultOptions={Object.values(this.state.selectedOptions)}
          styles={{ optionsStyle: optionsStyles }}
          onActiveCallback={this.handleProductOptionClick.bind(this)}
        />
      )
    }
    
    return (
      <Select
        placeholder="Select Variant ..."
        name="variants"
        styles={selectStyles}
        className={className}
        value={variantSelected}
        options={this.variantOptions()}
        isClearable={false}
        isSearchable={false}
        onChange={x => this.onVariantsChange(x)}
      />
    );
  }
}

export default connect(
  ({ product, order, settings: { style = {}, setting = {} }}) => ({
    variants: product.data.variants,
    options: product.data.options,
    variantSelected: order.variantSelected,
    setting: setting,
    optionsStyles: style.button || style.submit,
    selectStyles: customSelectStyles(style.select),
  }),
  dispatch => ({
    setVariantsQuantity: (a, b, c) => dispatch(setVariantsQuantity(a, b, c)),
  }),
)(Index);
